import SectionTitle from '@/components/common/SectionTitle';
import { Container } from '@pwskills/rachnaui';
import React, { useContext } from 'react';
import CategoryPageContext from '@/context/CategoryPageContext';
import NewsCards from '@/components/common/NewsCard';

const FeaturedInNews = () => {
  const { categoryDetails } = useContext(CategoryPageContext);
  const news = categoryDetails?.news;

  return (
    <section className="!bg-white ">
      <Container className="py-8 bg-white">
        <div className="flex flex-col">
          <div className="mb-[24px] medium:mb-[45px]">
            <SectionTitle upperText="Featured" lowerText="In The News" />
          </div>
          <div className="mt-6">{news && <NewsCards newsData={news} />}</div>
        </div>
      </Container>
    </section>
  );
};

export default FeaturedInNews;
